
import { NotDisturbModeScreenNavigationProps } from "./types"
import React from "react"
import FontsizeSettings from "./fontsize-settings"
import { PageRoot } from "~screens/page-root"


// 通知铃声
const FontsizeSettingsScreen: React.FC<NotDisturbModeScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <FontsizeSettings route={route}/>
    </PageRoot>
  )
}

export default FontsizeSettingsScreen
